export const formatProtectedClass = (protectedClass: string) => {
  return protectedClass
    .replaceAll(' ', '')
    .replaceAll('Code', '')
    .replaceAll('Gender', 'Sex')
}
